import { ProjectDetailsWizardStep } from "../../models";
import { isStepInvalid, isSubStepCurrent, isSubStepHighlighted } from "../../utils";

interface ProjectDetailsWizardSectionProps {
  step: ProjectDetailsWizardStep;
  stepNumber: number;
  isCurrent: boolean;
  isExpanded: boolean;
  selectedSubStep: string[] | undefined;
  onStepSelect: (stepKey: string) => void;
  onStepExpandToggle: (stepKey: string) => void;
  onSubStepSelect: (stepKey: string, subStepKey: string) => void;
}

export const ProjectDetailsWizardSection = ({
  step,
  stepNumber,
  isCurrent,
  isExpanded,
  selectedSubStep,
  onStepSelect,
  onStepExpandToggle,
  onSubStepSelect,
}: ProjectDetailsWizardSectionProps): JSX.Element => {
  const hasSubSteps = step.subSteps.length > 0;
  const stepIsInvalid = isStepInvalid(step);

  const handleStepClick = (): void => {
    if (hasSubSteps) {
      onStepExpandToggle(step.key);
    } else {
      onStepSelect(step.key);
    }
  };

  return (
    <div className={`ProjectDetailsWizardSection${isCurrent ? " Current" : ""}${stepIsInvalid ? " Invalid" : ""}`}>
      <div className="ProjectDetailsWizardSectionRow">
        <button
          type="button"
          className="ProjectDetailsWizardSectionButton"
          aria-label={`Open ${step.stepHeader}`}
          onClick={handleStepClick}
        >
          <div className="ProjectDetailsWizardStepIndicator">
            <p className="body2">{stepNumber}</p>
          </div>
          <p className="body2 ProjectDetailsWizardSectionLabel">{step.stepHeader}</p>
        </button>
        {hasSubSteps && (
          <button
            type="button"
            className="ProjectDetailsWizardExpandButton"
            onClick={() => onStepExpandToggle(step.key)}
            aria-label={`${isExpanded ? "Collapse" : "Expand"} ${step.stepHeader}`}
          >
            {isExpanded ? "\u2212" : "+"}
          </button>
        )}
      </div>
      {hasSubSteps && isExpanded && (
        <div className="ProjectDetailsWizardSubSteps">
          {step.subSteps.map((subStep) => {
            const subStepIsCurrent = isSubStepCurrent(subStep, selectedSubStep, step.key);
            const subStepIsHighlighted = isSubStepHighlighted(subStep, selectedSubStep, step.key);

            return (
              <button
                key={subStep.key}
                type="button"
                className={`ProjectDetailsWizardSubStepButton${subStepIsCurrent ? " Current" : ""}`}
                onClick={() => onSubStepSelect(step.key, subStep.key)}
                aria-label={`Open ${subStep.stepName}`}
              >
                <div className={`ProjectDetailsWizardSubStepIndicator${subStepIsHighlighted ? " Highlighted" : ""}`} />
                <p className="body3 ProjectDetailsWizardSubStepLabel">{subStep.stepName}</p>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
